//SOURCE:  Ben Nadel, blog post https://www.bennadel.com/blog/1504-ask-ben-parsing-csv-strings-with-javascript-exec-regular-expression-command.htm
function CSVToArray(strData, strDelimiter) {
  // Check to see if the delimiter is defined. If not,
  // then default to comma.
  strDelimiter = strDelimiter || ",";
  // Create a regular expression to parse the CSV values.
  var objPattern = new RegExp(
    // Delimiters.
    "(\\" +
      strDelimiter +
      "|\\r?\\n|\\r|^)" +
      // Quoted fields.
      '(?:"([^"]*(?:""[^"]*)*)"|' +
      // Standard fields.
      '([^"\\' +
      strDelimiter +
      "\\r\\n]*))",
    "gi"
  );
  // Create an array to hold our data. Give the array
  // a default empty first row.
  var data = [];
  // Create an array to hold our individual pattern
  // matching groups.
  var arrMatches = null;
  var currentValue = {};
  var count = 0;
  // Keep looping over the regular expression matches
  // until we can no longer find a match.
  while ((arrMatches = objPattern.exec(strData))) {
    // Get the delimiter that was found.
    var strMatchedDelimiter = arrMatches[1];
    // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.
    if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      data.push(currentValue);
      currentValue = {};
      count = 0;
    }
    // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).
    if (arrMatches[2]) {
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      var strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
    } else {
      // We found a non-quoted value.
      var strMatchedValue = arrMatches[3];
    }
    // Now that we have our value string, let's add
    // it to the data array.
    switch (count) {
      case 0:
        currentValue.first_name = strMatchedValue;
        break;
      case 1:
        currentValue.last_name = strMatchedValue;
        break;
      case 2:
        currentValue.phone = strMatchedValue;
        break;
      case 3:
        currentValue.address = strMatchedValue;
        break;
      case 4:
        currentValue.city = strMatchedValue;
        break;
      case 5:
        currentValue.state = strMatchedValue;
        break;
      case 6:
        currentValue.zip = strMatchedValue;
        break;
      case 7:
        currentValue.gender = strMatchedValue;
        break;
      case 8: 
        currentValue.polling_location = strMatchedValue;
        break;
      case 9:
        currentValue.party = strMatchedValue;
    }
    count++;
  }
  if (
    currentValue.first_name !== "" &&
    currentValue.last_name !== "" &&
    currentValue.phone !== ""
  ) {
    data.push(currentValue);
  }
  // Return the parsed data.
  return data;
}

export default CSVToArray;
